<!-- <div class="modal-header">
  <h3 class="modal-title">Delete Data</h3>
  <div class="header-actions">
    <i class="fa fa-times" style="cursor: pointer;" (click)="onCancel()"></i>
  </div>
</div> -->
<div class="modal-content">
  <gtw-confirmation-modal
    [config]="confirmConfig"
    [visible]="false"
    (confirmed)="onConfirm()"
    (cancelled)="onCancel()"
    (closed)="onCancel()">
  </gtw-confirmation-modal>
</div>
